import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Checkbox, Row, Col, Input } from 'antd';
import { uniqueId, map } from 'lodash';
import { TextInput, AlertBox, SelectInput } from '@life-line-lab/components-react';
import { useTranslation } from 'react-i18next';
import countriesStates from './countriesStates.json';
import statesCities from './country_MY.json'
import './address-form.scss';

interface AddressProps {
    data: any;
    isError: any;
    onChange: (value: string | string[], name: string) => void;
    index: any;
}

const AddressForm: React.FC<AddressProps> = ({data, isError, onChange, index}) => {
    const { t } = useTranslation();

    const stateID= uniqueId('state-dropdown');
    const countryID=uniqueId('country-dropdown');

    const initialInput = {
        type: "",
        street1: "",
        street2: "",
        city: "",
        cityCode: "", 
        stateCode: "",
        postcode: "",
        state: "",
        country:'MY',
    }
    
    const initialAddressError = '';
    const { Option } = Select;
    const [ address, setAddress ] = useState<any>(initialInput);
    const [ error, setError ] = useState<any>(initialAddressError);
    const [ stateOption, setStateOption ] = useState<any>([]);
    const [ countryOption, setCountryOption ] = useState<any>([]);
    const [citiesOption, setCitiesOption] = useState<any>([]);


    //Retrieve countries list from json
    useEffect(()=>{
        setAddress({...address, ...data});
        let countries:any = []
        map(countriesStates, (country: {name: string, code: string, states: string[]}) => { 
             countries.push({ value: country.code, label: country.name});
        });
        setCountryOption(countries);
    },[data])

    //Retrieve states list from json based on selected country
    useEffect(()=>{
        let states:any=[];
       
        map(countriesStates,(country: {name: string, code: string, states: string[]}) =>{
            if(address.country==country.name || address.country==country.code) {
                return country.states.map((name)=>{
                    states.push({value: name, label: name});
                })
            }
        });

        setStateOption(states);
    },[address.country])

    //Retrieve cities list based on selected country
    useEffect(() => {
        let cities: any = [];
        map(statesCities.STATES, (state)=>{
            if(address.state===state.NAME){
                return state.CITIES.map((city)=>{
                    cities.push({value: city.NAME, label: city.NAME})
                });
            }
        });
        setCitiesOption(cities);
    },[address.state])

    // pass cityCode when city changes
  useEffect(() => {
    map(statesCities.STATES, (state) => {
      state.CITIES.map((city) => {
        if (address.city === city.NAME) {
          setAddress({ ...address, cityCode: city.CODE });
        }
      })
    });
  }, [address.city])

  // pass stateCode when state changes
  useEffect(() => {
    map(statesCities.STATES, (state) => {
      if (address.state === state.NAME) {
        setAddress({ ...address, stateCode: state.CODE });
      }
    });
  }, [address.state])


  const handleStateCityChange = (value: string | string[], name: string) => {
    switch (name) {
      case "state":
        setError(initialAddressError);
        setAddress({ ...address, cityCode: "", city: "", [name]: value });
        
        onChange(value, name);
        break;
      case "country":
        setError(initialAddressError);
        setAddress({ ...address, stateCode: "", state: "", [name]: value });
        onChange(value, name);
        break;
      default:
    }
  }
    
    const handleSelectChange = (value: string | string[], name: string) => {
        setError(initialAddressError);
        setAddress({...address, [name]: value});
        onChange(value, name);
    }

    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setError(initialAddressError);
        setAddress({...address, [e.target.name]: e.target.value});
        onChange(e.target.value, e.target.name);
    }

    return (
        <div className="address-form">
            <h4 className="title">{index >= 0?t('title.editAddress'):t('title.addAddress')}</h4>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <SelectInput 
                        placeholder={t('label.type')}
                        className="text-input"
                        disabled = {true}
                        isRequired={true}
                        label={t('label.type')}
                        value={address.type}
                        isError={!!isError.type} 
                        name="type" 
                        onChange={
                            (value: string | string[]) => handleSelectChange(value, 'type')
                        }
                        options={[
                            {value: 'OFFICE', label: t('option.office')},
                            {value: 'HOME', label: t('option.home')},
                            {value: 'WAREHOUSE', label: t('option.warehouse')},
                            // {value: 'RESIDENTIAL', label: t('option.residential')},
                            // {value: 'COMMERCIAL', label: t('option.commercial')},
                        ]}
                    />
                    <AlertBox text={isError.type} />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    
                </Col>
            </Row>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <TextInput 
                        placeholder={t('label.street1')}
                        disabled = {true}
                        className="text-input"
                        isError={!!isError.street1} 
                        isRequired={true}
                        label={t('label.street1')}
                        name="street1" 
                        value={address.street1}
                        onChange={(event)=>handleTextChange(event)}
                    />
                    <AlertBox text={isError.street1} />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <TextInput 
                        className="text-input"
                        placeholder={t('label.street2')}
                        isError={!!isError.street2} 
                        isRequired={false}
                        label={t('label.street2')}
                        name="street2" 
                        value={address.street2}
                        onChange={(event)=>handleTextChange(event)}
                    />
                    <AlertBox text={isError.street2} />
                </Col>
            </Row>
            <Row>
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <TextInput 
                        className="text-input"
                        placeholder={t('label.postcode')}
                        isError={!!isError.postcode} 
                        isRequired={true}
                        label={t('label.postcode')}
                        name="postcode" 
                        value={address.postcode}
                        onChange={(event)=>handleTextChange(event)}
                    />
                    <AlertBox text={isError.postcode} />
                </Col>
            
            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <SelectInput 
                        placeholder={t('label.country')}
                        label={t('label.country')}
                        className="text-input"
                        isRequired={true}
                        isError={!!isError.country} 
                        name="country" 
                        value={address.country}
                        onChange={
                            (value: string | string[]) => handleStateCityChange(value, 'country')
                        }
                        options={countryOption}
                    />
                    <div id={countryID}/>
                    <AlertBox text={isError.country} />
                </Col>
                </Row>
                <Row>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <SelectInput 
                        placeholder={t('label.state')}
                        label={t('label.state')}
                        className="text-input"
                        
                        isRequired={true}
                        isError={!!isError.state} 
                        name="state" 
                        disabled={!address.country?true: false}
                        value={address.state}
                        onChange={
                            (value: string | string[]) => handleStateCityChange(value, 'state')
                        }
                        options={stateOption}
                    />
                    <div id={stateID}/>
                    <AlertBox text={isError.state} />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <SelectInput 
                        isReadonly={false}
                        className="text-input"
                        isError={!!isError.city} 
                        isRequired={true}
                        label={t('label.city')}
                        name="city" 
                        value={address.city}
                        onChange={ (value: string | string[]) => handleSelectChange(value, 'city')}
                        options={citiesOption!==null ? citiesOption : []}
                    />
                    <AlertBox text={isError.city} />
                </Col>
            </Row>
            
            {/* <div>
                <Checkbox checked={defaultAddress} >{t('txt.setAsDefaultAddress')}</Checkbox>
            </div> */}
        </div>
    )
}

export default AddressForm;
